module.exports = __webpack_public_path__ + "static/img/mapImg.ca05707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mapImg.jpg
// module id = pmAi
// module chunks = 0